import React from 'react';
import { graphql } from 'gatsby';
import { Tabs } from '@keytrade/components-tabs';

import Blocks from '@/components/blocks';
import BlockWrapper from '@/components/BlockWrapper';
import { getFontColorByBackground } from '@/utils/StyleUtils';
import Container from '@/components/Container';
import { LargeCardBlockType } from '@/components/blocks/LargeCardsBlock';
import { TilesBlockType } from '@/components/blocks/TilesBlock';

type TabPage = {
  title: string;
  content: LargeCardBlockType | TilesBlockType;
};
export type TabPagesBlockType = {
  __typename: string;
  id: string;
  backgroundColor: string;
  tabItems: Array<TabPage>;
  narrow?: boolean;
};
type Props = TabPagesBlockType;

const TabPagesBlock: React.FC<Props> = (props) => {
  let tabsTheme;
  const { narrow, backgroundColor, tabItems } = props;
  switch (backgroundColor) {
    case 'White':
    case 'Blue gradient':
    case 'Transparent':
      tabsTheme = 'light';
      break;
    case 'TransparentDark':
    case 'Light blue':
      tabsTheme = 'lightInverted';
      break;
    case 'Dark blue':
    case 'Dark blue gradient':
      tabsTheme = 'dark';
      break;
  }

  return (
    <BlockWrapper
      id={props.id}
      padding='none'
      color={
        backgroundColor === 'TransparentDark' ? 'Transparent' : backgroundColor
      }
    >
      <Container narrow={narrow}>
        <Tabs
          withBorder
          type='pills'
          colorScheme={tabsTheme}
          styledComponentsV4
          data={tabItems.map((tab) => {
            const block = tab.content.__typename.replace('Contentful', '');
            if (typeof Blocks[block] === 'undefined') return null;

            return {
              name: tab.title,
              content: Blocks[block]({
                ...tab.content,
                noContainer: true,
                textColor: getFontColorByBackground(backgroundColor),
                backgroundColor: backgroundColor,
              }),
            };
          })}
          addHash
        />
      </Container>
    </BlockWrapper>
  );
};

export default TabPagesBlock;

export const tabPagesBlockFragmentQuery = graphql`
  fragment TabPagesBlockFragment on ContentfulTabPagesBlock {
    id
    __typename
    backgroundColor
    tabItems {
      title
      content {
        ... on ContentfulLargeCardsBlock {
          ...LargeCardsBlockFragment
        }

        ... on ContentfulTilesBlock {
          ...TilesBlockFragment
        }

        ... on ContentfulRichTextBlock {
          ...RichTextBlockFragment
        }
      }
    }
  }
`;
